(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rider-brand-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rider-brand-disclosure').forEach(menu => {
  let timer;
  menu.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(timer); document.querySelectorAll('.rider-brand-disclosure,.rider-helmet-disclosure').forEach(other => { if (other !== menu) other.open = false; }); menu.open = true; } });
  menu.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) timer = setTimeout(() => { menu.open = false; }, 180); });
  menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rider-helmet-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rider-helmet-disclosure').forEach(menu => {
  let timer;
  menu.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(timer); menu.open = true; } });
  menu.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) timer = setTimeout(() => { menu.open = false; }, 180); });
  menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
  document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.open = false; });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rs-equipment-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.rs-equipment-disclosure').forEach(menu=>{
 let timer;
 menu.addEventListener('mouseenter',()=>{if(matchMedia('(hover:hover)').matches){clearTimeout(timer);menu.open=true;}});
 menu.addEventListener('mouseleave',()=>{if(matchMedia('(hover:hover)').matches)timer=setTimeout(()=>menu.open=false,180);});
 menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
 menu.addEventListener('focusout',e=>{if(!menu.contains(e.relatedTarget))menu.open=false;});
 document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.open=false;});
});
  } catch(e) { console.error(e); }
})();

})();
